module.exports = __webpack_public_path__ + "static/sparklingice-6e106f18cd977d94b550ebdf92e80aa3.png";